import { render, staticRenderFns } from "./StockviewDashboard.vue?vue&type=template&id=2b431918&"
import script from "./StockviewDashboard.vue?vue&type=script&lang=js&"
export * from "./StockviewDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports